import React from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { TINH_API } from '@app/utils/apiUrl.js';
import { useMutation } from 'react-query';
import { Post } from '@app/utils/httpProvider';
import { messageToast, status200, status201 } from '@app/utils/define';

const schema = yup.object().shape({
    maTinh: yup
        .number()
        .typeError('Mã tỉnh/thành phố phải là số nguyên')
        .integer('Mã tỉnh/thành phố phải là số nguyên')
        .positive('Mã tỉnh/thành phố phải lớn hơn 0')
        .required('Mã tỉnh/thành phố không được để trống'),
    tenTinh: yup.string().trim().required('Tên tỉnh/thành phố không được để trống')
});

const TinhAdd = () => {
    const history = useHistory();

    const addFunc = useMutation((value) => Post(TINH_API.ADD_ITEM, null, value, false));

    const handleCreate = async (values) => {
        const payload = {
            maTinh: Number(values.maTinh),
            tenTinh: values.tenTinh.trim()
        };

        addFunc.mutate(payload, {
            onSuccess: (res) => {
                if (res && (res.status === status200 || res.status === status201)) {
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.goBack();
                } else {
                    toast.error(messageToast.messageToastCreateError);
                }
            },
            onError: (err) => {
                toast.error(err?.message || 'Đã có lỗi xảy ra, vui lòng thử lại!');
            }
        });
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm tỉnh / thành phố</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        maTinh: '',
                        tenTinh: ''
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Mã tỉnh / TP <span className="text-danger">*</span>
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Nhập mã tỉnh / thành phố (ví dụ: 1, 2, ...)"
                                        type="number"
                                        name="maTinh"
                                        value={values.maTinh}
                                        onChange={handleChange}
                                        isInvalid={!!errors.maTinh}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.maTinh}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Tên tỉnh / TP <span className="text-danger">*</span>
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Nhập tên tỉnh / thành phố"
                                        type="text"
                                        name="tenTinh"
                                        value={values.tenTinh}
                                        onChange={handleChange}
                                        isInvalid={!!errors.tenTinh}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.tenTinh}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup>
                                        <Button type="submit" theme="primary" disabled={addFunc.isLoading}>
                                            Thêm
                                        </Button>
                                        <Button
                                            type="button"
                                            theme="secondary"
                                            onClick={() => history.goBack()}
                                        >
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </Card>
    );
};

export default TinhAdd;
